import { Injectable } from '@angular/core';
import { Router, RouterEvent, ResolveEnd, Event } from '@angular/router';
import { filter } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class ResolveEndRouterService {
  private initApp: boolean;

  constructor(private readonly router: Router) {
    this.initResolveEndListener();
  }

  setInitApp(value: boolean): void {
    this.initApp = value;
  }

  getInitApp(): boolean {
    return this.initApp;
  }

  private initResolveEndListener() {
    this.router.events
      .pipe(filter((event: Event | RouterEvent) => event instanceof ResolveEnd))
      .subscribe(() => {
        this.initApp = false;
      });
  }
}
